export const NEW_PERSON = "new_person";
export const NEW_CPO = "new_cpo";
export const FETCH_PEOPLE = "fetch_people";
export const FETCH_CPO = "fetch_CPO";
export const UPDATE_CPO = "update_CPO";
export const FETCH_OSCASES = "fetch_osases";
export const UPDATE_OSCASES = "update_osases";
export const NEW_OSCASE = "new_oscase";
